export default __webpack_public_path__ + "static/box_2-c247387a3a4410490bbf2163409d1bc6.png";